import TeleportView from "pages/Teleport"
import { Route, Routes } from "react-router-dom"

export const Routers = () => (
  <Routes>
    <Route path="/" Component={TeleportView} />
  </Routes>
)
